import { render, staticRenderFns } from "./CardCargoVehicleEntry.vue?vue&type=template&id=121b3107"
import script from "./CardCargoVehicleEntry.vue?vue&type=script&lang=js"
export * from "./CardCargoVehicleEntry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports